var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useRecordContext, useTranslate, usePreference } from 'ra-core';
export var PageTitle = function (_a) {
    var title = _a.title, defaultTitle = _a.defaultTitle, className = _a.className, rest = __rest(_a, ["title", "defaultTitle", "className"]);
    var titleFromPreferences = usePreference()[0];
    var translate = useTranslate();
    var record = useRecordContext();
    return titleFromPreferences ? (React.createElement("span", __assign({ className: className }, rest), translate(titleFromPreferences, __assign(__assign({}, record), { _: titleFromPreferences })))) : (React.createElement("span", { className: className }, !title ? (React.createElement("span", __assign({}, rest), defaultTitle)) : typeof title === 'string' ? (React.createElement("span", __assign({}, rest), translate(title, { _: title }))) : (title)));
};
//# sourceMappingURL=PageTitle.js.map